module.exports = __webpack_public_path__ + "img/orange_069.15997cc1.png";